import { handle } from 'redux-pack';
import { PhotoSessionSummary } from 'models/PhotoSessionSummary';
import { logUncaught } from 'utils/log';

const makePhotoSessionList = (photoSessionsList, photoSessionGroupedByDate) =>
  [
    ...photoSessionsList,
    ...(photoSessionGroupedByDate.scheduleList.map(PhotoSessionSummary.createFrom)),
  ];

export const getNotStarted = (photoSessions) =>
  photoSessions.reduce(makePhotoSessionList, []);

export const partitionNotStartedPhotoSessions = (photoSessions) => {
  const notStarted = [];
  const toReschedule = [];

  photoSessions.forEach((photoSession) => {
    if (photoSession.hasProblem) {
      toReschedule.push(photoSession);
    } else {
      notStarted.push(photoSession);
    }
  });

  return { notStarted, toReschedule };
};

export const handleNotStartedPhotoSessions = (prevState, action, error) => {
  if (error) {
    const statusCodes = action.payload.response && action.payload.response.status;

    logUncaught(
      new Error('[Failure fetching not started photo sessions]'),
      {
        state: prevState,
        payload: action.payload,
      }
    );

    return statusCodes === 403
      ? prevState
      : {
        ...prevState,
        showNotStartedListError: true,
        hasFetchedNotStartedPhotoSessions: true,
      };
  }

  const { notStarted, toReschedule } = partitionNotStartedPhotoSessions(
    getNotStarted(action.payload.scheduled),
  );

  return {
    ...prevState,
    notStarted,
    toReschedule,
    showNotStartedListError: false,
    hasFetchedNotStartedPhotoSessions: true,
  };
};

export const handleNotStartedPhotoSessionsLifecycle = (action) => ({
  success: (prevState) => handleNotStartedPhotoSessions(prevState, action, false),
  failure: (prevState) => handleNotStartedPhotoSessions(prevState, action, true),
});

export const addNotStartedPhotoSessionsToState = (state, action) =>
  handle(state, action, handleNotStartedPhotoSessionsLifecycle(action));
